import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import RankingSection from "./components/RankingSection";
import EditorPicks from "./components/EditorPicks";
import BrowseSection from "./components/BrowseSection";
import CollectionSection from "./components/CollectionSection";
import GuideSection from "./components/GuideSection";
import FaqSection from "./components/FaqSection";
import SubscribeSection from "./components/SubscribeSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <RankingSection />
        <EditorPicks />
        <BrowseSection />
        <CollectionSection />
        <GuideSection />
        <FaqSection />
        <SubscribeSection />
      </main>
      <Footer />
    </div>
  );
}